var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
export const JsonTableMixin = (superClass) => {
    class JsonTableClass extends superClass {
        constructor() {
            super(...arguments);
            this.data = null;
            this.payload = {};
            this.defaultHeaders = new Set();
        }
        firstUpdated() {
            if (!this.data) {
                this.data = [];
            }
        }
        filter(event) {
            if (event.key !== 'Enter')
                return;
            const inputs = event.currentTarget.querySelectorAll('input');
            const filterData = {};
            inputs.forEach(input => {
                if (input.value)
                    filterData[input.name] = input.value;
            });
            this.payload = filterData;
        }
        async readAsync() {
            const headers = new Headers();
            headers.append('Content-Type', 'application/json');
            const response = await fetch(`/logging/logging/read`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(this.payload)
            });
            if (!response.ok)
                throw new Error(`HTTP error! status: ${response.status}`);
            this.data = await response.json();
        }
        updated(changedProperties) {
            if (changedProperties.has('payload')) {
                this.readAsync();
            }
        }
        render() {
            const headers = this.getUniqueFields(this.data);
            return html `
        <table>
          <thead>
            <tr>
              ${headers.map((header) => html `<th>${header}</th>`)}
            </tr>
            <tr @keydown=${this.filter}>
                ${headers.map((header) => html `<td><input type="text" name="${header}"/></td>`)}
            </tr>
          </thead>
          <tbody>
            ${this.data?.map((item) => this.renderRow(item, headers))}
          </tbody>
        </table>
      `;
        }
        getUniqueFields(data) {
            const allFields = new Set();
            data?.forEach((item) => Object.keys(item).forEach((key) => allFields.add(key)));
            const headers = Array.from(allFields);
            if (headers.length === 0)
                return Array.from(this.defaultHeaders);
            if (this.defaultHeaders.size === 0)
                this.defaultHeaders = allFields;
            return headers;
        }
        renderRow(item, headers) {
            return html `
        <tr>
          ${headers.map((header) => {
                const value = item[header];
                return html `<td>${typeof value === 'string' || typeof value === 'number' ? value : ''}</td>`;
            })}
        </tr>
      `;
        }
    }
    __decorate([
        property({ attribute: false }),
        __metadata("design:type", Object)
    ], JsonTableClass.prototype, "data", void 0);
    __decorate([
        property({ attribute: false }),
        __metadata("design:type", Object)
    ], JsonTableClass.prototype, "payload", void 0);
    __decorate([
        property({ attribute: false }),
        __metadata("design:type", Set)
    ], JsonTableClass.prototype, "defaultHeaders", void 0);
    ;
    return JsonTableClass;
};
export const QboJsonTable = JsonTableMixin(LitElement);
//# sourceMappingURL=qbo-jsontable.js.map